import { ElementType } from 'react';
import { Trans } from 'react-i18next';
import { NotificationMessageBlock } from '@notifications/components/NotificationMessageBlock';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import { ROUTES } from '@routes/routes';
import { NotificationPresenter } from '@notifications/interfaces';
import { CompetitionStatusNotificationData } from './interfaces';

const isCompetitionStatusPayload = (
  payload: unknown
): payload is CompetitionStatusNotificationData => {
  if (typeof payload !== 'object' || payload === null) {
    return false;
  }

  return (
    'competitionName' in payload && typeof payload.competitionName === 'string'
  );
};

const createCompetitionStatusPresenter = (
  type: 'competition-stopped' | 'competition-resumed',
  badgeIcon: ElementType,
  openCompetition: boolean
): NotificationPresenter<CompetitionStatusNotificationData> => ({
  type,
  icon: EmojiEventsIcon,
  badgeIcon,
  isPayload: isCompetitionStatusPayload,
  label: (payload, t) =>
    t(`notifications:types.${type}`, {
      competitionName: payload.competitionName,
    }),
  message: (payload) => (
    <Trans
      i18nKey={`notifications:menu.${type}`}
      values={{
        competitionName: payload.competitionName,
      }}
      components={{
        bold: <strong />,
      }}
    />
  ),
  body: (payload) => {
    const message =
      type === 'competition-stopped'
        ? payload.stopReason
        : payload.resumeMessage;

    if (!message) {
      return null;
    }

    return <NotificationMessageBlock>{message}</NotificationMessageBlock>;
  },
  path: (payload) => {
    if (!openCompetition || !payload.competitionSlug) {
      return null;
    }

    return ROUTES.portal.competitions.details(payload.competitionSlug);
  },
});

export const competitionStatusPresenters: NotificationPresenter<CompetitionStatusNotificationData>[] =
  [
    createCompetitionStatusPresenter(
      'competition-stopped',
      StopIcon,
      false
    ),
    createCompetitionStatusPresenter(
      'competition-resumed',
      PlayArrowIcon,
      true
    ),
  ];
